export default __webpack_public_path__ + "static/media/ax.3882371f.svg";